import { useMemo } from "react";
import { Card, SystemLogFeed, type SystemLogEntry } from "randmarcomps";
import { Job as ApiJob } from "randmar-api-client";

interface IProps {
  jobs?: ApiJob[];
}

const normalizeValue = (value?: string | null): string => {
  if (!value) {
    return "-";
  }
  const trimmed = value.trim();
  return trimmed.length > 0 ? trimmed : "-";
};

const formatPayload = (job: ApiJob): string => {
  const fileNames = job.Header?.FileNames?.length
    ? job.Header.FileNames.join(", ")
    : "-";

  return [
    `status: ${normalizeValue(job.Header?.Status)}`,
    `type: ${normalizeValue(job.Header?.Type)}`,
    `job_id: ${normalizeValue(job.Header?.JobId)}`,
    `application_id: ${normalizeValue(job.Header?.ApplicationId)}`,
    `description: ${normalizeValue(job.Header?.Description)}`,
    `comment: ${normalizeValue(job.Header?.Comment)}`,
    `files: ${fileNames}`,
  ].join("\n");
};

const JobsGrid = ({ jobs: rawJobs }: IProps) => {
  const jobs = useMemo(() => rawJobs ?? [], [rawJobs]);

  const logEntries = useMemo<SystemLogEntry[]>(
    () => jobs.map((job, index) => ({
      id: job.Header?.JobId || `${job.Header?.CreatedAt || "unknown"}-${index}`,
      timestamp: new Date((job.Header?.CreatedAt || 0) * 1000),
      payload: formatPayload(job),
    })),
    [jobs]
  );

  if (!jobs || jobs.length === 0) {
    return (
      <div className="grid place-items-center text-center">
        <p>There are no jobs!</p>
      </div>
    );
  }

  return (
    <Card className="p-4 sm:p-6">
      <SystemLogFeed
        entries={logEntries}
        emptyStateText="There are no jobs!"
      />
    </Card>
  );
};

export default JobsGrid;
